import { Loader } from '@devd-client/devd/components';
import React, { Suspense } from 'react';

const MsTeamsInstallation = React.memo(
  React.lazy(() =>
    import('@devd-client/devd/ui-shared').then((module) => ({
      default: module.MsTeamsInstallation,
    }))
  )
);

export function AsyncMsTeamsInstallation() {
  return (
    <Suspense fallback={<Loader />}>
      <MsTeamsInstallation />
    </Suspense>
  );
}
